import { getArticleFollowCount } from "@/libs/api/api";
import { message, errorHandler, logout, loader } from "@/libs/helper";
import constants from "@/libs/constant/constants";
export default {
  props: {
    getURL: {
      type: Function,
      default: () => {},
    },
    onError: {
      type: Function,
      default: () => {},
    },
    details: {
      type: Object,
      default: () => {},
    },
    module: {
      type: String,
      default: "",
    },
    followUnfollowAction: {
      type: Function,
      default: () => {},
    },
    fetchMetaDetails: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      filterRows: [
        {
          filter: "",
          operator: "",
          value: [],
        },
      ],
      articleCount: 0,
      pubDateOptions: {
        shortcuts: [
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last 3 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  watch: {
    filterRows: {
      deep: true,
      immediate: true,
      handler() {
        this.getArticleCount(false);
      },
    },
  },
  computed: {
    getAllowedFilters() {
      switch (this.module) {
        case "AUTHOR":
          return [
            { label: "Publications", value: "publication" },
            { label: "Published Date", value: "pub_date" },
          ];
        case "PUBLICATION":
          return [
            { label: "Authors", value: "author" },
            { label: "Published Date", value: "pub_date" },
          ];
        case "PUBLISHER":
          return [
            { label: "Authors", value: "author" },
            { label: "Publications", value: "publication" },
            { label: "Published Date", value: "pub_date" },
          ];
      }
    },
    getAllowedOperators() {
      return {
        publication: {
          OPERATION: [
            {
              key: "IN",
              value: "in",
            },
            {
              key: "NOT_IN",
              value: "not in",
            },
          ],
        },
        author: {
          OPERATION: [
            {
              key: "IN",
              value: "in",
            },
            {
              key: "NOT_IN",
              value: "not in",
            },
          ],
        },
        pub_date: {
          OPERATION: [
            {
              key: "published_till",
              value: "before",
            },
            {
              key: "published_from",
              value: "after",
            },
            {
              key: "between",
              value: "between",
            },
          ],
        },
        "": {
          OPERATION: [],
        },
      };
    },
  },
  methods: {
    addFilterRow() {
      const row = {
        filter: "",
        operator: "",
        value: null,
      };
      this.filterRows.push(row);
    },
    deleteFilterRow(index) {
      this.filterRows.splice(index, 1);
    },
    async getArticleCount(follow = false) {
      loader(this, true);
      const { _id } = this.details;
      const data = { _id, follow };

      this.filterRows.forEach((row) => {
        if (!row.filter) return;

        if (row.filter === "pub_date") {
          data[row.filter] = {};

          const fromDate = row.value[0] && row.value[0].toISOString();
          const toDate = row.value[1] && row.value[1].toISOString();

          if (row.value.length === 1) {
            data[row.filter][row.operator] = fromDate;
          } else if (row.value.length > 1) {
            data[row.filter].published_from = fromDate;
            data[row.filter].published_till = toDate;
          }
        } else {
          data[row.filter] = {
            ids: row.value,
            operator: row.operator || "IN",
          };
        }
      });

      try {
        const response = await getArticleFollowCount(
          this.module.toLowerCase(),
          data
        );

        if (follow) {
          this.fetchMetaDetails();
          this.$emit("close");
          message(this, constants.messageType.SUCCESS, 'Followed Successfully');
        }

        this.articleCount = response.count;
        loader(this, false);
      } catch (error) {
        loader(this, false);
        console.error(error);
        message(
          this,
          constants.messageType.ERROR,
          errorHandler(error, logout.bind(this, this))
        );
      }
    },
    resetRow(index) {
      this.filterRows[index].operator =
        this.getAllowedOperators[
          this.filterRows[index].filter
        ].OPERATION[0].key;
      this.filterRows[index].value = [];
    },
    resetRowValue(index) {
      this.filterRows[index].value = [];
    },
  },
};
